"use strict";
/**
 * Created by Marvin on 20.03.17.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var redux_form_1 = require("redux-form");
var react_redux_1 = require("react-redux");
var actions_1 = require("../actions");
var helpers_1 = require("../helpers");
var find_in_object_1 = __importDefault(require("@wikom/find-in-object"));
var redux_form_2 = require("redux-form");
var FormErrors_1 = __importDefault(require("./FormErrors"));
var actions_2 = require("../actions");
var react_router_dom_1 = require("react-router-dom");
var Form = /** @class */ (function (_super) {
    __extends(Form, _super);
    function Form() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Form.prototype.componentDidMount = function () {
        typeof this.props.asyncValidate === 'function' ? setTimeout(this.props.asyncValidate, 0) : null;
    };
    Form.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.form !== nextProps.form && typeof nextProps.asyncValidate === 'function') {
            setTimeout(nextProps.asyncValidate, 0);
        }
    };
    Form.prototype.render = function () {
        return (react_1["default"].createElement("form", { onSubmit: this.props.handleSubmit(this.props.onSubmit) }, react_1["default"].cloneElement(this.props.children, __assign({}, this.props))));
    };
    return Form;
}(react_1["default"].Component));
var FormWrapper = /** @class */ (function (_super) {
    __extends(FormWrapper, _super);
    function FormWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.container = (0, redux_form_1.reduxForm)({
            shouldAsyncValidate: function (_a) {
                var trigger = _a.trigger;
                return trigger === 'submit';
            }
        })(Form);
        return _this;
    }
    FormWrapper.prototype.render = function () {
        return react_1["default"].createElement(this.container, __assign({}, this.props));
    };
    return FormWrapper;
}(react_1["default"].Component));
function mapState(state, _a) {
    var name = _a.name, checkUrl = _a.checkUrl, initialValues = _a.initialValues;
    var _b = (0, FormErrors_1["default"])((0, find_in_object_1["default"])('formErrors.' + name, state)), FieldError = _b.FieldError, hasErrors = _b.hasErrors, isValidated = _b.isValidated;
    var submitting = (isValidated() && (((0, find_in_object_1["default"])('form.' + name + '.asyncValidating', state) === true))) ||
        (0, find_in_object_1["default"])('form.' + name + '.submitting', state);
    return {
        form: name,
        FieldError: FieldError,
        hasErrors: hasErrors,
        isValidated: isValidated,
        submitting: submitting,
        formValues: (0, find_in_object_1["default"])('form.' + name + '.values', state),
        initialValues: Object.assign({}, (0, helpers_1.initialValuesFromURL)(name), initialValues),
        asyncValidate: checkUrl ? (0, actions_1.asyncValidate)({ name: name, url: checkUrl }) : false,
        onChange: checkUrl ? (0, actions_1.handleChange)({ name: name, url: checkUrl }) : false
    };
}
function mapDispatch(dispatch, _a) {
    var name = _a.name, submitHandler = _a.submitHandler, successHandler = _a.successHandler;
    return {
        reset: function () { return dispatch((0, redux_form_2.reset)(name)); },
        onSubmit: function (data) { return dispatch(submitHandler(data))
            // @ts-ignore
            .then(function (result) { return dispatch(successHandler(result)); })["catch"](function (err) { return dispatch(actions_2.formErrorsActions.setFormErrorsFromSubmit(name, err.response.body)); }); }
    };
}
// @ts-ignore
var ConnectedFormWrapper = (0, react_redux_1.connect)(mapState, mapDispatch)(FormWrapper);
var ConnectFormContainer = function (_a) {
    var name = _a.name, submitHandler = _a.submitHandler, successHandler = _a.successHandler, rest = __rest(_a, ["name", "submitHandler", "successHandler"]);
    var go = (0, react_router_dom_1.useHistory)().go;
    var handleSuccess = successHandler || (function () { return function () { return go(-1); }; });
    return (react_1["default"].createElement(ConnectedFormWrapper, __assign({ name: name, submitHandler: submitHandler, successHandler: handleSuccess }, rest)));
};
exports["default"] = ConnectFormContainer;
